import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import FullWidthImageWithQuote from "./FullWidthImageWithQuote"
import CentredContentContainer from '../Widgets/CentredContentContainer'
import Carousel from './Carousel'

const PrevNextContainer = props => <CentredContentContainer>{props.children}</CentredContentContainer>

class FullWidthImageWithQuoteCarousel extends PureComponent {
    render() {
        const {classes, item} = this.props;

        return <Carousel
            prevNextContainer={PrevNextContainer}
            items={item.items.map((x, i) => (<div key={i} className={classes.flickityCell}><FullWidthImageWithQuote classNames={classes} item={x} /></div>))}>
        </Carousel>
    }
}

export default injectSheet((theme) => ({
    flickityCell: {
        width: '100%',
        marginRight: 20
    },
    fullWidthContainer: {
        marginBottom: 0
    }
}))(FullWidthImageWithQuoteCarousel)


// WEBPACK FOOTER //
// ./src/components/Article/FullWidthImageWithQuoteCarousel.js